import React from 'react';
import { ConfluenceIcon } from '@atlaskit/logo/confluence-icon';
import { JiraIcon } from '@atlaskit/logo/jira-icon';
import { CONFLUENCE_GENERATOR_ID, JIRA_GENERATOR_ID } from '../common/constants';
export var extractEntity = function extractEntity(response) {
  return response === null || response === void 0 ? void 0 : response.entityData;
};
export var isEntityPresent = function isEntityPresent(response) {
  return Boolean(extractEntity(response));
};
export var extractEntityEmbedUrl = function extractEntityEmbedUrl(response) {
  var entity = extractEntity(response);
  return entity && 'liveEmbedUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl) === 'string' ? entity === null || entity === void 0 ? void 0 : entity.liveEmbedUrl : undefined;
};
export var extractEntityProvider = function extractEntityProvider(response) {
  var _response$meta;
  if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && _response$meta.generator)) {
    return undefined;
  }
  var _ref = response.meta.generator,
    icon = _ref.icon,
    id = _ref.id,
    image = _ref.image,
    name = _ref.name;
  if (!name || !icon) {
    throw Error('Link.generator requires a name and icon.');
  }
  var providerIcon;
  switch (id) {
    case CONFLUENCE_GENERATOR_ID:
      providerIcon = /*#__PURE__*/React.createElement(ConfluenceIcon, {
        appearance: "brand",
        size: "xxsmall"
      });
      break;
    case JIRA_GENERATOR_ID:
      providerIcon = /*#__PURE__*/React.createElement(JiraIcon, {
        appearance: "brand",
        size: "xxsmall"
      });
      break;
    default:
      providerIcon = icon.url;
  }
  return {
    text: name,
    icon: providerIcon,
    id: id,
    image: image ? image : icon.url
  };
};
export var extractEntityIcon = function extractEntityIcon(response) {
  var entity = extractEntity(response);
  var url;
  if (entity) {
    var _response$meta$genera;
    url = 'iconUrl' in entity && typeof (entity === null || entity === void 0 ? void 0 : entity.iconUrl) === 'string' ? entity.iconUrl : response === null || response === void 0 || (_response$meta$genera = response.meta.generator) === null || _response$meta$genera === void 0 || (_response$meta$genera = _response$meta$genera.icon) === null || _response$meta$genera === void 0 ? void 0 : _response$meta$genera.url;
  }
  return {
    url: url,
    label: entity === null || entity === void 0 ? void 0 : entity.displayName
  };
};